import React from 'react'
import PropTypes from 'prop-types';
import moment from 'moment'
import Error from './form-input-error';

import DatePicker from 'react-datepicker'

import Label from '../label';

import 'react-datepicker/dist/react-datepicker.css'

//https://hacker0x01.github.io/react-datepicker/
//=> https://wangzuo.github.io/input-moment
class Datepicker extends React.Component {

    static propTypes = {
        label: PropTypes.string,
        date: PropTypes.object,
        minDate: PropTypes.object,
        maxDate: PropTypes.object,
        dateFormat: PropTypes.string,
        errorStr: PropTypes.string,
        disabled: PropTypes.bool,
        onChange: PropTypes.func
    }

    static defaultProps = {
        errorStr: 'app.error',
        disabled: false,
        dateFormat: 'DD-MMMM-YYYY',
    }

    state = {
        date: this.props.date || moment(),
        error: false
    }

    handleChange(date) {
        this.setState({date})

        this.onChangeTimeout && clearTimeout(this.onChangeTimeout);
        this.onChangeTimeout = setTimeout( () => this.onChange(date), this.props.waitInMs || Datepicker.WAIT_IN_MS)
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        this.setState({date: nextProps.date})
    }

    onChange(date) {
        let { onChange = false } = this.props
        if(!onChange) {
            return
        }
        let ret = onChange(date);
        let promise = ret.then ? ret : Promise.resolve(date)

        !promise._state && this.setState({loading: true})

        promise.then(e => this.setState({loading: false, error: false}))
            .catch( e => this.setState({loading: false, error: true}));
    }

    render() {
        let { label, minDate, maxDate, dateFormat, errorStr } = this.props
        let { error=false, loading=false, disabled, date } = this.state

        return <div className="form form-datepicker">
            <Label>{label}</Label>
            <div className={'form-value' + (error?' error':'')}>
                <DatePicker
                    {...{minDate}}
                    {...{maxDate}}
                    todayButton="app.today"
                    dateFormat={dateFormat}
                    selected={date}
                    disabled={disabled || loading}
                    onChange={this.handleChange.bind(this)} />
                <Error visible={error} message={errorStr} />
            </div>
    </div>
    }
}

export default Datepicker
